/* eslint-disable react/prop-types */
import React, { useLayoutEffect, useState } from 'react';
import { Button, Form, Input, message, Modal } from 'antd';

import { FileOutlined, PlusOutlined } from '@ant-design/icons';

import { api } from '../../Services/axiosService';
import TaskComment from '../Schedule/TaskComment';
import TaskCommentFunctions from '../Schedule/TaskCommentFunctions';

import './ModalIntercurrence.scss';

export default function ModalIntercurrence({
  currentOpenTask,
  eventSource,
  setShowModalIntercurrence,
}) {
  const [form] = Form.useForm();
  const [comentsTasks, setTaskComments] = useState();
  const [loading, setLoading] = useState(false);
  const eventSourceFormatted = eventSource
    ? eventSource.charAt(0).toUpperCase() + eventSource.slice(1)
    : '';

  const getComentsTasks = async () => {
    setLoading(true);
    await api
      .get(
        `/TaskComment?filters[0].Field=TaskId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${currentOpenTask?.id}&filters[1].Field=SourceType&filters[1].Condition=EQUAL&filters[1].Value=${eventSourceFormatted}TaskIntercurrence`
      )
      .then((res) => setTaskComments(res.data))
      .catch((error) => error);
    setLoading(false);
  };

  const addComentsTask = async () => {
    setLoading(true);

    await TaskCommentFunctions.addTaskComment(
      currentOpenTask,
      'TaskIntercurrence',
      eventSourceFormatted,
      form.getFieldValue('intercurrence')
    );

    message.success('Intercorrência adicionada!');
    getComentsTasks();
    form.resetFields();
    setLoading(false);
  };

  useLayoutEffect(() => {
    getComentsTasks();
  }, []);

  return (
    <Modal
      title="Registrar Intercorrência"
      open={true}
      onCancel={() => setShowModalIntercurrence(false)}
      cancelText="Fechar"
      maskClosable={false}
      okButtonProps={{ style: { display: 'none' } }}
      destroyOnClose
    >
      <Form
        form={form}
        name="modalIntercurrence"
        layout="vertical"
        autoComplete="off"
        onFinish={addComentsTask}
        preserve={false}
      >
        <Form.Item
          label="Nova Intercorrência"
          name="intercurrence"
          rules={[
            {
              required: true,
              message: 'Campo obrigatório!',
            },
          ]}
        >
          <Input.TextArea placeholder="Descreva a intercorrência..." rows={4} />
        </Form.Item>

        <div className="comments-container">
          <Button htmlType="submit" type="primary" icon={<PlusOutlined />} loading={loading}>
            Adicionar Intercorrência
          </Button>

          <h3>Histórico de Intercorrências</h3>

          {!loading && comentsTasks?.length > 0 && <TaskComment comments={comentsTasks} />}

          {comentsTasks?.length === 0 && (
            <div className="no-comments-container">
              <FileOutlined />
              <p>Nenhuma intercorrência registrada ainda.</p>
            </div>
          )}
        </div>
      </Form>
    </Modal>
  );
}
